customElements.define('zero-help-button', class extends HTMLElement {
    static observedAttributes = ['msg', 'data-resized']

    constructor() {
        super().attachShadow({mode: 'open'}).innerHTML = this.render()
        this.style.position = 'absolute'
    }

    wire() {
        const btn = this.shadowRoot.querySelector('button')

        btn.addEventListener('pointerover', () => this.showTip())
        btn.addEventListener('pointerout', () => this.hideTip())
        btn.addEventListener('keyup', (e) => {
            if(e.key === 'Enter') this.showTip()
        })
        btn.addEventListener('blur', () => this.hideTip())
    }

    showTip() {
        this.shadowRoot.querySelector('.popover').classList.add('open')
    }

    hideTip() {
        this.shadowRoot.querySelector('.popover').classList.remove('open')
    }

    attributeChangedCallback(_, oldVal, newVal) {
        if(!newVal) this.shadowRoot.innerHTML = ''
        if(newVal && newVal !== oldVal) {
            this.shadowRoot.innerHTML = this.render()
            this.wire()
        }
    }

    render() {
        this.style.setProperty('--color', this.getAttribute('color'))

        return `
            <style>
                * {
                    box-sizing: border-box;
                }

                :host {
                    --size: max(2vw, 3rem);
                    --padding: max(1vw, 1rem);
                    --font-size: clamp(1.4rem, 0.8vw, 3rem);

                    box-sizing: border-box;
                    display: block;
                    height: 100%;
                    padding: var(--padding);
                    pointer-events: none;
                    top: 0;
                    width: 100%;
                }

                button {
                    all: unset;
                    background-color: white;
                    border-radius: var(--size);
                    box-sizing: border-box;
                    display: grid;
                    height: var(--size);
                    margin-left: auto;
                    place-items: center;
                    pointer-events: auto;
                    transition: background 300ms ease;
                    width: var(--size);

                    &:hover, &:focus-visible {
                        background-color: var(--color);
                        cursor: pointer;

                        path {
                            fill: white;
                        }
                    }
                }

                svg {
                    width: 60%;
                }

                path {
                    fill: var(--color);
                    transition: fill 300ms ease;
                }

                .popover {
                    background-color: var(--color-1-dk);
                    border: none;
                    border-radius: var(--radius-sm);
                    box-shadow: 0 0.5rem 2rem 0 hsl(0 0% 0% / 0.3);
                    color: white;
                    font-size: var(--font-size);
                    height: fit-content;
                    line-height: 1.5;
                    margin: auto; 
                    max-width: calc(100% - 2rem);
                    opacity: 0;
                    outline: none;
                    padding: 0.5em 1em;
                    position: absolute;
                    right: 1rem;
                    top: calc(var(--size) + (var(--padding) + 2%));
                    translate: 0 -1rem;
                    transition: all 300ms ease 200ms;
                    visibility: hidden;
                    width: fit-content;

                    p {
                        font-weight: 600;
                        margin: 0;
                        padding: 0;
                    }

                    &.open {
                        opacity: 1;
                        translate: 0 0rem;
                        visibility: visible;
                    }
                }
            </style>

            <button>
                <svg width="100%" height="100%" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                    <path d="M7.45,11.836C7.45,12.72 7.993,13.433 9.154,13.433C10.218,13.433 10.495,12.837 11.027,12.187C11.485,11.634 11.985,11.251 12.624,10.857C13.795,10.133 15.19,9.27 15.19,7.163C15.19,4.458 12.912,3 9.707,3C7.823,3 6.439,3.5 5.619,4.214C5.13,4.639 4.81,5.193 4.81,5.789C4.81,6.534 5.311,7.248 6.311,7.248C6.854,7.248 7.184,7.035 7.621,6.747C8.089,6.439 8.621,6.258 9.186,6.258C9.973,6.258 10.825,6.62 10.825,7.471C10.825,8.291 10.048,8.717 9.239,9.292C8.121,10.09 7.45,10.857 7.45,11.836ZM6.865,16.041C6.865,17.265 7.866,18 9.09,18C10.303,18 11.304,17.265 11.304,16.041C11.304,14.828 10.303,14.093 9.09,14.093C7.866,14.093 6.865,14.828 6.865,16.041Z" style="fill-rule:nonzero;"/>
                </svg>
            </button>

            <div class="popover">
                <p>${this.getAttribute('msg')}</p>
            </div>
        `
    }
})